import { render, staticRenderFns } from "./StreamsGallery.vue?vue&type=template&id=bf12d4fc&scoped=true&"
import script from "./StreamsGallery.vue?vue&type=script&lang=js&"
export * from "./StreamsGallery.vue?vue&type=script&lang=js&"
import style0 from "./StreamsGallery.vue?vue&type=style&index=0&id=bf12d4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf12d4fc",
  null
  
)

export default component.exports